import Vue from 'vue';
import Vuex from 'vuex';

import trainCategoriesModule from './modules/trainCategories';
import stationsModule from './modules/stations';
import newsModule from './modules/news';
import searchModule from './modules/search';
import myTicketsModule from './modules/myTickets';
import userModule from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    trainCategories: trainCategoriesModule,
    stations: stationsModule,
    news: newsModule,
    search: searchModule,
    myTickets: myTicketsModule,
    user: userModule,
  },
});
